<template>
  <div id="wrapper">

    <div class="normalheader transition">
      <div class="hpanel">
        <div class="panel-body"  v-if="question && question.project">
          <a class="small-header-action" href="">
            <div class="clip-header">
              <i class="fa fa-arrow-up"></i>
            </div>
          </a>

          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li>
                <router-link :to="{name: 'Dashboard'}">Dashboard</router-link>
              </li>
              <li class="active">
                <span v-if="question.project.workflow_id === 3">Tech offer</span>
                <span v-else>Question</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs" v-if="question.project.workflow_id === 3">
             Technology offer
          </h3>
          <h3 class="font-light m-b-xs" v-else>
            Question
          </h3>
        </div>
      </div>
    </div>

    <div class="content" v-if="question && question.project">
      <question-resume :questionId="questionId" :projectId="question.project.id" :workflowId="question.project.workflow_id"/>

      <div class="row">
        <div class="col-xs-12 col-lg-6">
          <div class="hpanel ">
            <div class="panel-heading">
              Chat (<span style="font-size: 12px;font-style: italic">If you want to ask for clarification, make a suggestion, …</span>)
            </div>

            <chat :questionId="questionId"/>
          </div>
        </div>
        <div class="col-xs-12 col-lg-6">
          <div class="hpanel">
            <div class="panel-heading" v-if="question.project.workflow_id === 3">
              Your response (<span style="font-size: 12px;font-style: italic">If you are asked / you wish to send a response document about the Tech offer</span>)
            </div>
            <div class="panel-heading" v-else>
              Your Proposals (<span style="font-size: 12px;font-style: italic">If you are asked / you wish to send a proposal about the question</span>)
            </div>
            <solution :questionId="questionId" />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import QuestionListRow from './../../components/receiveQuestion/QuestionListRow'
import QuestionResumeLarge from '../../components/question/resume/QuestionResumeLarge'
import VueLadda from 'vue-ladda'
import Chat from '../../components/chatSolution/Chat'
import Solution from '../../components/chatSolution/Solution'
import QuestionResume from '../../components/question/QuestionResume'

export default {
  components: {
    QuestionResume,
    Solution,
    QuestionResumeLarge,
    QuestionListRow,
    VueLadda,
    Chat},
  props: [],
  name: 'ReceiveQuestion',
  methods: {
    getResources: function () {
      this.axios.get('/question/receive/' + this.questionId + '?relations={consultant.profile,project.owner.profile}')
        .then((response) => {
          this.question = response.data
        }).catch((error) => {
          if (error.response.status === 403) {
            this.$router.replace({name: 'Error403', params: {'0': ''}})
          }
          if (error.response.status === 404) {
            this.$router.replace({name: 'Error404', params: {'0': ''}})
          }
        })
    }
  },
  watch: {
  },
  data () {
    return {
      questionId: null,
      question: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  beforeMount () {
    this.questionId = parseInt(this.$route.params.question_id)
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/receiveQuestion/ReceiveQuestion.vue